import { useEffect, useMemo } from 'react'
import {
  useNavigate,
  useParams,
  // useParams
} from 'react-router-dom'

import {
  getClientDataWithGuidMT,
  getDataForClone,
  getDataWithMTGuid,
  getDataWithMTGuidBackoffice,
} from '@/api/motorTrade'
import {
  isMtBackofficeStore,
  motorTradeFormStore,
  motorTradeGuidStore,
  mtBrokerDetailStore,
  mtClientStore,
} from '@/store/MotorTradeFormStore'
import { MotorTradeBuyRouter } from '@/router/motorTradeBuyRouter'
import { MotorTradeGuidConvert } from '@/managers/MotorTradeGuidConvert'

// import { getDataWithGuid } from '@/api/commercialCombined'
// import { resetEverything } from '@/utils/Clean'
// import {
//   brokerGuidStore,
//   commercialCombinedFormStore,
// } from '@/store/CommercialCombinedFormStore'

export const backOfficeUrl = '/back-office'
export const brokerUrl = '/broker'

const MotorTradePopulate = () => {
  const navigate = useNavigate()
  const { guid, brokerId, brokerName, clientId } = useParams()

  const { setGuid } = motorTradeGuidStore()
  const { setBroker } = mtBrokerDetailStore()
  const { setBackoffice } = isMtBackofficeStore()
  const { setClient } = mtClientStore()
  const { setData } = motorTradeFormStore()

  const pathname = document.referrer

  const isBackOffice = useMemo(
    () => pathname.includes(`${backOfficeUrl}/`),
    [pathname]
  )

  const isBroker = useMemo(() => pathname.includes(`${brokerUrl}/`), [pathname])

  const urlPrefix = useMemo(() => {
    setBackoffice(!!isBackOffice)
    return isBackOffice ? `${backOfficeUrl}/` : isBroker ? `${brokerUrl}/` : '/'
  }, [isBackOffice, isBroker])

  const isMta =
    pathname.toLowerCase().startsWith(`${urlPrefix}buy/`) && guid != null
  console.log(isMta, 'isMta')
  // useEffect(() => {
  //   if (guid) {
  //     // clean up
  //     resetEverything(false)

  //     // get data
  //     getDataWithGuid(guid)
  //       .then((res) => {
  //         // expected res.data to be of type CommercialCombinedFormData
  //         setGuid(guid)
  //         setData({
  //           ...res.data,
  //         })
  //         navigate(BrokerBuyRouter.step1.href, {
  //           state: { from: 'commercialCombined' },
  //         })
  //       })
  //       .catch((reason) => {
  //         console.error(reason)
  //         resetEverything()
  //       })
  //   } else {
  //     navigate(BrokerBuyRouter.step1.href)
  //   }
  // }, [])

  useEffect(() => {
    setClient(clientId)
    setBroker({
      brokerName: brokerName,
      brokerId: brokerId,
    })

    if (clientId) {
      if (guid) {
        getDataForClone(guid)
          .then((res) => {
            setData(MotorTradeGuidConvert(res.data))
          })
          .catch((reason) => {
            console.log(reason)
          })
          .finally(() => {
            navigate(MotorTradeBuyRouter().step1.href, {
              state: { from: 'motorTrade' },
            })
          })

        return
      }

      getClientDataWithGuidMT(clientId)
        .then((res) => {
          setData(MotorTradeGuidConvert(res.data))
        })
        .catch((reason) => {
          console.log(reason)
        })
        .finally(() => {
          navigate(MotorTradeBuyRouter().step1.href, {
            state: { from: 'motorTrade' },
          })
        })
      return
    }

    if (guid) {
      if (isBackOffice) {
        getDataWithMTGuidBackoffice(guid)
          .then((res) => {
            setGuid(guid)
            setData(MotorTradeGuidConvert(res.data))
          })
          .finally(() => {
            navigate(MotorTradeBuyRouter().step1.href, {
              state: { from: 'motorTrade' },
            })
          })
        return
      }

      setGuid(guid)
      getDataWithMTGuid(guid)
        .then((res) => {
          setGuid(guid)
          setData(MotorTradeGuidConvert(res.data))
        })
        .finally(() => {
          navigate(MotorTradeBuyRouter().step1.href, {
            state: { from: 'motorTrade' },
          })
        })
    } else {
      navigate(MotorTradeBuyRouter().step1.href, {
        state: { from: 'motorTrade' },
      })
    }
  }, [])

  return <div>Retrieving data...</div>
}

export default MotorTradePopulate
